export enum REPORTS {
    /**
     * @value All types
     */
    ALL_RESOURCE_TYPE_FILTER = 'REPORTS.ALL_RESOURCE_TYPE_FILTER',
    /**
     * @value Comment
     */
    COMMENT = 'REPORTS.COMMENT',
    /**
     * @value Comments
     */
    COMMENTS = 'REPORTS.COMMENT_RESOURCE_TYPE_FILTER',
    /**
     * @value This comment has already been reviewed by another moderator.
     */
    COMMENT_COMPETITOR_ACCESS_MODAL_MESSAGE = 'REPORTS.COMMENT_COMPETITOR_ACCESS_MODAL_MESSAGE',
    /**
     * @value Comment already reviewed
     */
    COMMENT_COMPETITOR_ACCESS_MODAL_TITLE = 'REPORTS.COMMENT_COMPETITOR_ACCESS_MODAL_TITLE',
    /**
     * @value Comment is mandatory to report. Shortly explain the reason of your reporting.
     */
    COMMENT_IS_MANDATORY_ERROR = 'REPORTS.COMMENT_IS_MANDATORY_ERROR',
    /**
     * @value Reported comment
     */
    COMMENT_REVIEW_DIALOG_REPORTED_COMMENT = 'REPORTS.COMMENT_REVIEW_DIALOG_REPORTED_COMMENT',
    /**
     * @value Review this comment
     */
    COMMENT_REVIEW_DIALOG_TITLE = 'REPORTS.COMMENT_REVIEW_DIALOG_TITLE',
    /**
     * @value Reason is mandatory
     */
    DIALOG_REQUIRED_REASON = 'REPORTS.DIALOG_REQUIRED_REASON',
    /**
     * @value Comment kept published
     */
    DISMISS_REPORT_COMMENT_SUCCESS = 'REPORTS.DISMISS_REPORT_COMMENT_SUCCESS',
    /**
     * @value {"one":"element","other":"elements"}
     */
    ELEMENT_NUMBER = 'REPORTS.ELEMENT_NUMBER',
    /**
     * @value This page gives you access to all reported items you can review.
     */
    EMPTY_REVIEW_LIST_SUBTITLE = 'REPORTS.EMPTY_REVIEW_LIST_SUBTITLE',
    /**
     * @value Try another entry.
     */
    EMPTY_REVIEW_LIST_SUBTITLE_NO_MATCHING_RESULT = 'REPORTS.EMPTY_REVIEW_LIST_SUBTITLE_NO_MATCHING_RESULT',
    /**
     * @value There is no reported item yet
     */
    EMPTY_REVIEW_LIST_TITLE = 'REPORTS.EMPTY_REVIEW_LIST_TITLE',
    /**
     * @value No reports matched your search.
     */
    EMPTY_REVIEW_LIST_TITLE_NO_MATCHING_RESULT = 'REPORTS.EMPTY_REVIEW_LIST_TITLE_NO_MATCHING_RESULT',
    /**
     * @value The reported item is no longer available or cannot be found.
     */
    ERROR_REPORTED_RESOURCE_NOT_FOUND = 'REPORTS.ERROR_REPORTED_RESOURCE_NOT_FOUND',
    /**
     * @value Load more reports
     * @description "Load more button" label on the reports list page.
     */
    LOAD_MORE_REPORTS = 'REPORTS.LOAD_MORE_REPORTS',
    /**
     * @value This post has already been reviewed by another moderator.
     */
    POST_COMPETITOR_ACCESS_MODAL_MESSAGE = 'REPORTS.POST_COMPETITOR_ACCESS_MODAL_MESSAGE',
    /**
     * @value Post already reviewed
     */
    POST_COMPETITOR_ACCESS_MODAL_TITLE = 'REPORTS.POST_COMPETITOR_ACCESS_MODAL_TITLE',
    /**
     * @value Reported post
     */
    POST_REVIEW_DIALOG_REPORTED_POST = 'REPORTS.POST_REVIEW_DIALOG_REPORTED_POST',
    /**
     * @value Review this post
     */
    POST_REVIEW_DIALOG_TITLE = 'REPORTS.POST_REVIEW_DIALOG_TITLE',
    /**
     * @value Report
     */
    REPORT = 'REPORTS.REPORT',
    /**
     * @value Reports
     */
    REPORTS_TITLE = 'REPORTS.REPORTS_TITLE',
    /**
     * @value Moderators can see your name during the review process. You will receive a notification once the review is done.
     */
    REPORT_DIALOG_MESSAGE = 'REPORTS.REPORT_DIALOG_MESSAGE',
    /**
     * @value Sensitive data
     * @description Label for a report with the Sensitive data reason
     */
    REPORT_DIALOG_SENSITIVE_DATA_REASON = 'REPORTS.REPORT_DIALOG_SENSITIVE_DATA_REASON',
    /**
     * @value Select the reason of your report
     */
    REPORT_DIALOG_SUBTITLE = 'REPORTS.REPORT_DIALOG_SUBTITLE',
    /**
     * @value Report comment
     */
    REPORT_DIALOG_VALIDATE = 'REPORTS.REPORT_DIALOG_VALIDATE',
    /**
     * @value Review
     */
    REVIEW = 'REPORTS.REVIEW',
    /**
     * @value Keep it
     */
    REVIEW_DIALOG_DISMISS_REPORT_LABEL = 'REPORTS.REVIEW_DIALOG_DISMISS_REPORT_LABEL',
    /**
     * @value See content
     */
    SEE_CONTENT = 'REPORTS.SEE_CONTENT',
    /**
     * @value See post
     */
    SEE_POST = 'REPORTS.SEE_POST',
    /**
     * @value Thanks for your help!
     * @description The message displayed in the thanks dialog after successfully reporting a resource (content, post, comments...)
     */
    THANKS_DIALOG_MESSAGE = 'REPORTS.REPORT_THANKS_DIALOG_MESSAGE',
}
export enum REPORT_ALREADY_REPORTED {
    /**
     * @value Comment already reported
     */
    comment = 'REPORTS.COMMENT_REPORT_ALREADY_REPORTED',
    /**
     * @value Content already reported
     * @description Text displayed as a title of the dialog which inform the user that he already has reported this content
     */
    content = 'REPORTS.CONTENT_REPORT_ALREADY_REPORTED',
    /**
     * @value Post already reported
     */
    post = 'REPORTS.POST_REPORT_ALREADY_REPORTED',
}
export enum REPORT_ALREADY_REPORTED_DIALOG_MESSAGE {
    /**
     * @value You already have reported this comment.
     * @description Inform the user in a dialog that he already have reported the current comment.
     */
    comment = 'REPORTS.COMMENT_REPORT_ALREADY_REPORTED_DIALOG_MESSAGE',
    /**
     * @value You already have reported this content.
     * @description Message displayed when an user try to report a content that he already has reported
     */
    content = 'REPORTS.CONTENT_REPORT_ALREADY_REPORTED_DIALOG_MESSAGE',
    /**
     * @value You already have reported this post.
     * @description Inform the user in a dialog that he already have reported the current post.
     */
    post = 'REPORTS.POST_REPORT_ALREADY_REPORTED_DIALOG_MESSAGE',
}
export enum REPORT_DIALOG_TITLE {
    /**
     * @value Report this comment
     */
    comment = 'REPORTS.COMMENT_REPORT_DIALOG_TITLE',
    /**
     * @value Report this content
     * @description Text displayed as a title of the report dialog of a content
     */
    content = 'REPORTS.CONTENT_REPORT_DIALOG_TITLE',
    /**
     * @value Report this post
     * @description The title of the dialog displayed when reporting a post.
     */
    post = 'REPORTS.POST_REPORT_DIALOG_TITLE',
}
export enum REPORT_DIALOG_REASON_ERROR {
    /**
     * @value Error in comment
     */
    comment = 'REPORTS.COMMENT_REPORT_DIALOG_REASON_ERROR',
    /**
     * @value Error in content
     * @description Text displayed when the user have to pick for a report reason in a content report.
     */
    content = 'REPORTS.CONTENT_REPORT_DIALOG_REASON_ERROR',
    /**
     * @value Error in post
     * @description The label of the 'Error' reason when reporting a post.
     */
    post = 'REPORTS.POST_REPORT_DIALOG_REASON_ERROR',
}
export enum REPORT_DIALOG_INNAPROPRIATE_REASON {
    /**
     * @value Inappropriate content
     */
    comment = 'REPORTS.COMMENT_REPORT_DIALOG_INNAPROPRIATE_REASON',
    /**
     * @value Inappropriate content
     * @description Text displayed when the user have to pick for a report reason in a content report
     */
    content = 'REPORTS.CONTENT_REPORT_DIALOG_INNAPROPRIATE_REASON',
    /**
     * @value Inappropriate content
     * @description The label of the 'Inappropriate' reason when reporting a post
     */
    post = 'REPORTS.POST_REPORT_DIALOG_INNAPROPRIATE_REASON',
}
export enum REPORT_DIALOG_PRIVACY_REASON {
    /**
     * @value Privacy
     */
    comment = 'REPORTS.COMMENT_REPORT_DIALOG_PRIVACY_REASON',
    /**
     * @value Privacy
     * @description The label of the 'Privacy' reason when reporting a content
     */
    content = 'REPORTS.CONTENT_REPORT_DIALOG_PRIVACY_REASON',
    /**
     * @value Privacy
     * @description The label of the 'Privacy' reason when reporting a post
     */
    post = 'REPORTS.POST_REPORT_DIALOG_PRIVACY_REASON',
}
export enum REPORT_DIALOG_OUTDATED_REASON {
    /**
     * @value Outdated
     */
    comment = 'REPORTS.COMMENT_REPORT_DIALOG_OUTDATED_REASON',
    /**
     * @value Outdated
     */
    content = 'REPORTS.CONTENT_REPORT_DIALOG_OUTDATED_REASON',
    /**
     * @value Outdated
     */
    post = 'REPORTS.POST_REPORT_DIALOG_OUTDATED_REASON',
}
export enum REPORT_DIALOG_DUPLICATED_REASON {
    /**
     * @value Duplicated
     */
    comment = 'REPORTS.COMMENT_REPORT_DIALOG_DUPLICATED_REASON',
    /**
     * @value Duplicated
     */
    content = 'REPORTS.CONTENT_REPORT_DIALOG_DUPLICATED_REASON',
    /**
     * @value Duplicated
     */
    post = 'REPORTS.POST_REPORT_DIALOG_DUPLICATED_REASON',
}
export enum REVIEW_BLOCK_HEADER_BASE_MESSAGE {
    /**
     * @value {"one":"Comment reported by %LAST_REPORTER% %LAST_REPORT_DATE%.","other":"Comment reported by %LAST_REPORTER%, and %REPORTS_COUNT% other people %LAST_REPORT_DATE%."}
     * @description Plural will be displayed when more than one user reported the comment.
     * %LAST_REPORT_DATE% will be replaced by a localized relative date (ie. "4 days ago)
     * %LAST_REPORTER% will be replaced by the user name of the last reporter.
     * %REPORTS_COUNT% will be replaced by the number of reports available for the reported ressource
     *
     */
    comment = 'REPORTS.SINGLE_COMMENT_REPORT_BANNER_MESSAGE',
    /**
     * @value {"one":"Content reported by %LAST_REPORTER% %LAST_REPORT_DATE%.","other":"Content reported by %LAST_REPORTER%, and %REPORTS_COUNT% other people %LAST_REPORT_DATE%."}
     * @description Plural will be displayed when more than one user reported the comment.
     * %LAST_REPORT_DATE% will be replaced by a localized relative date (ie. "4 days ago)
     * %LAST_REPORTER% will be replaced by the user name of the last reporter.
     * %REPORTS_COUNT% will be replaced by the number of reports available for the reported ressource
     */
    content = 'REPORTS.SINGLE_CONTENT_REPORT_BANNER_MESSAGE',
    /**
     * @value {"one":"Post reported by %LAST_REPORTER% %LAST_REPORT_DATE%.","other":"Post reported by %LAST_REPORTER%, and %REPORTS_COUNT% other people %LAST_REPORT_DATE%."}
     * @description Plural will be displayed when more than one user reported the comment.
     * %LAST_REPORT_DATE% will be replaced by a localized relative date (ie. "4 days ago)
     * %LAST_REPORTER% will be replaced by the user name of the last reporter.
     * %REPORTS_COUNT% will be replaced by the number of reports available for the reported ressource
     */
    post = 'REPORTS.SINGLE_POST_REPORT_BANNER_MESSAGE',
}
export enum REVIEW_DIALOG_TITLE {
    /**
     * @value Review this comment
     */
    comment = 'REPORTS.COMMENT_REVIEW_DIALOG_TITLE',
    /**
     * @value Review this content
     */
    content = 'REPORTS.CONTENT_REVIEW_DIALOG_TITLE',
    /**
     * @value Review this post
     */
    post = 'REPORTS.POST_REVIEW_DIALOG_TITLE',
}
export enum REVIEW_DIALOG_REPORTED_RESOURCE {
    /**
     * @value Reported comment
     */
    comment = 'REPORTS.COMMENT_REVIEW_DIALOG_REPORTED_COMMENT',
    /**
     * @value Reported content
     */
    content = 'REPORTS.CONTENT_REVIEW_DIALOG_REPORTED_CONTENT',
    /**
     * @value Reported post
     */
    post = 'REPORTS.POST_REVIEW_DIALOG_REPORTED_POST',
}
export enum REVIEW_DIALOG_APPROVE_REPORT_LABEL {
    /**
     * @value Hide comment
     */
    comment = 'REPORTS.COMMENT_REVIEW_DIALOG_APPROVE_REPORT_LABEL',
    /**
     * @value Unpublish content
     */
    content = 'REPORTS.CONTENT_REVIEW_DIALOG_APPROVE_REPORT_LABEL',
    /**
     * @value Delete post
     */
    post = 'REPORTS.POST_REVIEW_DIALOG_APPROVE_REPORT_LABEL',
}
export enum ACCEPT_REPORT_SUCCESS {
    /**
     * @value Comment hidden
     */
    comment = 'REPORTS.ACCEPT_REPORT_COMMENT_SUCCESS',
    /**
     * @value Content unpublished
     */
    content = 'REPORTS.ACCEPT_REPORT_CONTENT_SUCCESS',
    /**
     * @value Post deleted
     */
    post = 'REPORTS.ACCEPT_REPORT_POST_SUCCESS',
}
export enum DISMISS_REPORT_SUCCESS {
    /**
     * @value Comment kept published
     */
    comment = 'REPORTS.DISMISS_REPORT_COMMENT_SUCCESS',
    /**
     * @value Content kept published
     */
    content = 'REPORTS.DISMISS_REPORT_CONTENT_SUCCESS',
    /**
     * @value Post kept published
     */
    post = 'REPORTS.DISMISS_REPORT_POST_SUCCESS',
}
export enum COMPETITOR_ACCESS_MODAL_TITLE {
    /**
     * @value Comment already reviewed
     */
    comment = 'REPORTS.COMMENT_COMPETITOR_ACCESS_MODAL_TITLE',
    /**
     * @value Content already reviewed
     */
    content = 'REPORTS.CONTENT_COMPETITOR_ACCESS_MODAL_TITLE',
    /**
     * @value Post already reviewed
     */
    post = 'REPORTS.POST_COMPETITOR_ACCESS_MODAL_TITLE',
}
export enum COMPETITOR_ACCESS_MODAL_MESSAGE {
    /**
     * @value This comment has already been reviewed by another moderator.
     */
    comment = 'REPORTS.COMMENT_COMPETITOR_ACCESS_MODAL_MESSAGE',
    /**
     * @value This content has already been reviewed by another moderator.
     */
    content = 'REPORTS.CONTENT_COMPETITOR_ACCESS_MODAL_MESSAGE',
    /**
     * @value This post has already been reviewed by another moderator.
     */
    post = 'REPORTS.POST_COMPETITOR_ACCESS_MODAL_MESSAGE',
}
export enum SENSITIVE_DATA_WARNING {
    /**
     * @value Comment published with sensitive data detected.
     * @description Text to display when a comment as been published with sensitive data.
     */
    comment = 'REPORTS.COMMENT_WITH_SENSITIVE_DATA',
    /**
     * @value Content published with sensitive data detected.
     * @description Text to display when a content as been published with sensitive data.
     */
    content = 'REPORTS.CONTENT_WITH_SENSITIVE_DATA',
    /**
     * @value Post published with sensitive data detected.
     * @description Text to display when a post as been published with sensitive data.
     */
    post = 'REPORTS.POST_WITH_SENSITIVE_DATA',
}
